/*
 * @Author: 温少昌 wenshaochang@huizhihuyu.com
 * @Date: 2024-07-23 10:04:49
 * @LastEditors: 温少昌 wenshaochang@huizhihuyu.com
 * @LastEditTime: 2024-07-23 11:06:24
 * @FilePath: /ny-utils-master/src/auth/loginDeployOfH5.js
 * @Description: 部署公众号的登录
 */
export const loginDeployOfH5 = function loginDeployOfH5() {
    console.log('公众号登录')
}